import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FileHandler from '../../components/FileHandler';
import { getDocuments, getApplicantId } from './reducer';
import { actions as applicationAction } from '../Application';

const mapStateToProps = state => ({
  loading: state.documents.loading,
  documents: state.documents.documents,
  applicantId: state.documents.applicantId,
  identityId: state.app.identityId,
  minUcComment: state.documents.minUcComment,
  idProofComment: state.documents.idProofComment,
  rentalBaseComment: state.documents.rentalBaseComment,
  rentalAgreementComment: state.documents.rentalAgreementComment,
  incomeBaseComment: state.documents.incomeBaseComment,
  minUcStatus: state.documents.minUcStatus,
  idProofStatus: state.documents.idProofStatus,
  rentalBaseStatus: state.documents.rentalBaseStatus,
  rentalAgreementStatus: state.documents.rentalAgreementStatus,
  incomeBaseStatus: state.documents.incomeBaseStatus,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDocuments,
      getApplicantId,
      getCase: applicationAction.fetchCase,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FileHandler);



// WEBPACK FOOTER //
// ./src/features/FileHandler/index.js